import useAuthStore from "@/stores/useAuthStore";
import SHA256 from "crypto-js/sha256";
import type { FetchLike, WretchOptions } from "wretch";
import { LOCAL_STORAGE_LANG } from "@/constants/normal";

const hashMiddleware = (next: FetchLike) => async (url: string, opts: WretchOptions) => {
  const token = useAuthStore.getState().token || "";
  const locale = localStorage.getItem(LOCAL_STORAGE_LANG)?.toLowerCase();

  const combine = {
    token,
    locale,
  };

  const hash256 = SHA256(JSON.stringify(combine)).toString();

  opts.headers = {
    ...opts.headers,
    "X-Hash": hash256,
  };

  return next(url, opts);
};

export default hashMiddleware;
